export var INVALID_RESOURCE_ERR = new Error('Invalid resource type');
export var SHARE_METHODS = {
  PHONE: 'sms',
  EMAIL: 'email',
  PRINT: 'print'
};
export var RESOURCE_TYPES = {
  provider: 'provider',
  program: 'program'
};
export var RESOURCE_TEXT = {
  provider: 'Organization',
  program: 'Program'
};
export var ADDRESS_TYPES = {
  CLIENT: 'client',
  USER: 'user',
  GROUP: 'ours',
  OTHER: 'otherAddr'
};
export var SEARCH_API_STATES = ['AK', 'AL', 'AR', 'AS', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MP', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UM', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY', 'AA', 'AE', 'AP'];
export var SENSITIVE_PROGRAMS = {
  NONE: 'none',
  SOME: 'some',
  ALL: 'all'
};
export var SENSITIVE_PROGRAM_SUPPORT_MESSAGES = {
  NONE: '',
  SOME: 'You\'re sharing at least one sensitive service. Do not include sensitive information in your message.',
  ALL: 'You\'re sharing sensitive services. Messaging is not permitted.'
};
export var PLACEHOLDER_TEXT = 'Enter a message that\'s 400 characters or less.';
//# sourceMappingURL=constants.js.map